import React, { useEffect, useState } from 'react';
import {
    Box,
    Grid,
    TextField,
    Button,
    Typography,
    Select,
    MenuItem,
    InputLabel,
    FormControl,
    Table,
    TableHead,
    TableRow,
    TableCell,
    Autocomplete,
    IconButton,
    Card,
    Divider,
    Stack,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { auth, db } from '../../firebase';
import {
    collection,
    addDoc,
    Timestamp,
    query,
    orderBy,
    onSnapshot, doc,
    where, runTransaction, increment,
} from 'firebase/firestore';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import Shopheader from '../Shop/Shopheader';
import Mashalheader from '../Mashal/Mashalheader'
import Wholesalerheader from '../Wholesale/Wholesaleheader';

export default function Sale() {
    const { category } = useParams();
    const navigate = useNavigate();

    const [userData, setUserData] = useState(null);
    const [custommers, setcustommers] = useState([]);
    const [products, setProducts] = useState([]);
    const [SaleItems, setSaleItems] = useState([]);

    const [customerId, setcustomerId] = useState('');
    const [SaleDate, setSaleDate] = useState('');
    const [paytype, setPaytype] = useState('Cash');
    const [whatsapp, setwhatsapp] = useState('No');

    const [itemId, setItemId] = useState('');
    const [qty, setQty] = useState(1);
    const [rate, setRate] = useState('');
    const [discount, setDiscount] = useState(0);

    const [subtotal, setSubtotal] = useState('');
    const [totalAmount, setTotalAmount] = useState('');
    const [grandTotal, setGrandTotal] = useState(0);
    const [paidAmount, setPaidAmount] = useState(0);
    const [remaining, setRemaining] = useState(0);

    const [SaleDocId, setSaleDocId] = useState('');

    useEffect(() => {
        auth.onAuthStateChanged((user) => {
            setUserData(user);
        });
    }, []);

    useEffect(() => {
        fetchProductsAndcustomers();
        const today = new Date();
        setSaleDate(today.toISOString().split('T')[0]);
    }, [category]);

    const fetchProductsAndcustomers = async () => {
        try {
            const qcustomers = query(collection(db, 'customers'), where('category', '==', category));
            onSnapshot(qcustomers, (snap) => {
                setcustommers(snap.docs.map((doc) => ({ id: doc.id, data: doc.data() })));
            });

            const qProducts = query(
                collection(db, 'products'),
                where('category', '==', category),
                orderBy('productname', 'asc')
            );
            onSnapshot(qProducts, (snap) => {
                setProducts(snap.docs.map((doc) => ({ id: doc.id, data: doc.data() })));
            });
        } catch (error) {
            toast.error(error.message);
        }
    };

    // ---------------- CALCULATIONS ----------------
    const calculateItemTotal = (r, q, d) => {
        const subtotal = parseFloat(r || 0) * parseFloat(q || 0) - parseFloat(d || 0);
        return parseFloat(subtotal.toFixed(2));
    };

    const updateGrandTotal = (items) => {
        const total = items.reduce((acc, item) => acc + parseFloat(item.totalAmount || 0), 0);
        setGrandTotal(total.toFixed(2));
        setRemaining((total - parseFloat(paidAmount || 0)).toFixed(2));
    };

    // ---------------- HANDLE PRODUCT SELECT ----------------
    const handleProductSelect = (prodId) => {
        setItemId(prodId);
        const selected = products.find((p) => p.id === prodId);
        if (selected) {
            const r = parseFloat(selected.data.salerate || 0);
            setRate(r);
            const subtotal = calculateItemTotal(r, qty, discount);
            setSubtotal(subtotal);
            setTotalAmount(subtotal);
        }
    };

    const handleQtyOrDiscountChange = (newQty, newDiscount, newRate) => {
        const subtotal = calculateItemTotal(newRate, newQty, newDiscount);
        setSubtotal(subtotal);
        setTotalAmount(subtotal);
    };


    const addSaleItems = () => {
        if (!itemId || !rate || !qty) {
            toast.error('Please fill required fields!');
            return;
        }

        const newItem = {
            itemId,
            qty: parseFloat(qty),
            rate: parseFloat(rate),
            discount: parseFloat(discount),
            totalAmount: parseFloat(totalAmount),
        };

        const updatedItems = [...SaleItems, newItem];
        setSaleItems(updatedItems);

        // Update grand total
        updateGrandTotal(updatedItems);

        // Reset item input
        setItemId('');
        setQty(1);
        setRate('');
        setDiscount(0);
        setSubtotal('');
        setTotalAmount('');

        toast.success('Item added locally');
    };


    const saveSale = async () => {
        if (!customerId || !SaleDate || SaleItems.length === 0) {
            toast.error('Please select customer, date and add items!');
            return;
        }

        try {
            // 1️⃣ Get or create counter doc BASED ON CATEGORY
            const counterRef = doc(db, "counters", `salesCounter_${category}`);

            let SaleNo;
            await runTransaction(db, async (transaction) => {
                const counterDoc = await transaction.get(counterRef);
                if (!counterDoc.exists()) {
                    // If counter doc doesn’t exist → create it with start value 1
                    transaction.set(counterRef, { current: 1 });
                    SaleNo = 1;
                } else {
                    const newCount = (counterDoc.data().current || 0) + 1;
                    transaction.update(counterRef, { current: increment(1) });
                    SaleNo = newCount;
                }
            });

            // 2️⃣ Save Sale with category-wise SaleNo
            const SaleRef = await addDoc(collection(db, 'sales'), {
                SaleNo, // ✅ Bill No (per category)
                customerId,
                SaleDate,
                grandTotal: parseFloat(grandTotal),
                paidAmount: parseFloat(paidAmount),
                remaining: parseFloat(remaining),
                paytype,
                category,
                status: 'Pending',
                uid: userData?.uid,
                created: Timestamp.now(),
            });

            const saleId = SaleRef.id;

            // 3️⃣ Save Sale items
            const batchPromises = SaleItems.map((item) =>
                addDoc(collection(db, 'salesitems'), {
                    saleid: saleId,
                    SaleNo,
                    customerId,
                    SaleDate,
                    ...item,
                    category,
                    status: 'Pending',
                    uid: userData?.uid,
                    created: Timestamp.now(),
                })
            );

            // 4️⃣ Save payment history
            if (parseFloat(paidAmount) > 0) {
                await addDoc(collection(db, 'customerpaymenthistory'), {
                    customerId,
                    saleId,
                    SaleNo,
                    paymentDate: SaleDate,
                    amount: parseFloat(paidAmount),
                    paytype,
                    uid: userData?.uid,
                    created: Timestamp.now(),
                });
            }

            await Promise.all(batchPromises);

            toast.success(`Sale #${SaleNo} saved successfully (${category})`);

            // Reset form
            setSaleItems([]);
            setcustomerId('');
            setGrandTotal(0);
            setPaidAmount(0);
            setRemaining(0);

        } catch (error) {
            toast.error(error.message);
        }
    };


    return (
        <Box p={2}>
            {category === "shop" && <Shopheader />}
            {category === "mashal" && <Mashalheader />}
            {category === "wholesaler" && <Wholesalerheader />}
            {/* ---------------- HEADER ---------------- */}
            <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                mb={3}
            >
                <Button
                    variant="outlined"
                    color="secondary"
                    onClick={() => navigate(`/view-sale/${category}`)}
                >
                    विक्री बघा
                </Button>
                <Typography variant="h5" fontWeight="bold" color="primary">
                    नवीन विक्री
                </Typography>
            </Stack>

            <Card sx={{ p: 3, borderRadius: 3, boxShadow: 3 }}>
                {/* ---------------- CUSTOMER SECTION ---------------- */}
                <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                    ग्राहकांची माहिती
                </Typography>
                <Divider sx={{ mb: 2 }} />

                <Grid container className="row">
                    <Grid className="col-sm-3 mb-3" item xs={12} sm={6} md={3}>
                        <FormControl fullWidth size="small">
                            <InputLabel>ग्राहक </InputLabel>
                            <Autocomplete
                                options={custommers}
                                getOptionLabel={(option) => option.data?.name || ""}
                                value={custommers.find((c) => c.id === customerId) || null}
                                onChange={(e, newValue) => setcustomerId(newValue ? newValue.id : "")}
                                renderInput={(params) => (
                                    <TextField {...params} label="ग्राहक" size="small" fullWidth />
                                )}
                            />
                        </FormControl>
                    </Grid>

                    <Grid className="col-sm-3 mb-3" item xs={12} sm={6} md={3}>
                        <TextField
                            fullWidth
                            type="date"
                            label="विक्री दिनांक "
                            InputLabelProps={{ shrink: true }}
                            value={SaleDate}
                            onChange={(e) => setSaleDate(e.target.value)}
                            size="small"
                        />
                    </Grid>
                </Grid>

                {/* ---------------- ITEMS SECTION ---------------- */}
                <Box mt={4}>
                    <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                        प्रोडक्ट
                    </Typography>
                    <Divider sx={{ mb: 2 }} />

                    {/* Input Row */}
                    <div className="row mb-3">
                        <div className="col-sm-2 mt-2">
                            <FormControl fullWidth size="small">
                                <Autocomplete
                                    options={products}
                                    getOptionLabel={(option) => option.data?.productname || ""}
                                    value={products.find((p) => p.id === itemId) || null}
                                    onChange={(e, newValue) => {
                                        if (newValue) {
                                            handleProductSelect(newValue.id);
                                        } else {
                                            setItemId("");
                                        }
                                    }}
                                    renderInput={(params) => (
                                        <TextField {...params} label="प्रोडक्ट" size="small" fullWidth />
                                    )}
                                />

                            </FormControl>
                        </div>

                        <div className="col-sm-2 mt-2">
                            <TextField
                                label=" रेट "
                                value={rate}
                                size="small"
                                fullWidth
                                onChange={(e) => {
                                    const newRate = e.target.value;
                                    setRate(newRate);
                                    handleQtyOrDiscountChange(qty, discount, newRate);
                                }}
                            />
                        </div>

                        <div className="col-sm-2 mt-2">
                            <TextField
                                label="नग "
                                value={qty}
                                size="small"
                                fullWidth
                                onChange={(e) => {
                                    const newQty = e.target.value;
                                    setQty(newQty);
                                    handleQtyOrDiscountChange(newQty, discount, rate);
                                }}
                            />
                        </div>

                        <div className="col-sm-2 mt-2">
                            <TextField
                                label="डिस्काउंट "
                                value={discount}
                                size="small"
                                fullWidth
                                onChange={(e) => {
                                    const newDiscount = e.target.value;
                                    setDiscount(newDiscount);
                                    handleQtyOrDiscountChange(qty, newDiscount, rate);
                                }}
                            />
                        </div>

                        <div className="col-sm-2 mt-2">
                            <TextField
                                label="टोटल "
                                value={totalAmount}
                                size="small"
                                fullWidth
                                InputProps={{ readOnly: true }}
                            />
                        </div>

                        <div className="col-sm d-flex align-items-center">
                            <IconButton
                                color="primary"
                                onClick={addSaleItems}
                                sx={{ bgcolor: "primary.light", color: "#fff", "&:hover": { bgcolor: "primary.main" } }}
                            >
                                <AddIcon />
                            </IconButton>
                        </div>
                    </div>

                    {/* Sale Items List */}
                    <Box sx={{ border: "1px solid #eee", borderRadius: 2, p: 2 }}>
                        {SaleItems.map((item, i) => (
                            <div
                                className="row border-bottom py-2"
                                key={i}
                                style={{ transition: "0.2s", cursor: "pointer" }}
                            >
                                <div className="col-sm-2">{products.find((p) => p.id === item.itemId)?.data.productname || item.itemId}</div>
                                <div className="col-sm-2">{item.rate}</div>
                                <div className="col-sm-2">{item.qty}</div>
                                <div className="col-sm-2">{item.discount}</div>
                                <div className="col-sm-2">{item.totalAmount}</div>
                                <div className="col-sm-2">
                                    <IconButton color="error">
                                        <DeleteIcon />
                                    </IconButton>
                                </div>
                            </div>
                        ))}
                    </Box>
                </Box>

                {/* ---------------- PAYMENT SECTION ---------------- */}
                <Box mt={4}>
                    <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                        टोटल
                    </Typography>
                    <Divider sx={{ mb: 2 }} />

                    <Grid container className="row">
                        <Grid className="col-sm-2 mb-3" item xs={12} sm={6} md={3}>
                            <TextField
                                label="ग्रँड टोटल "
                                fullWidth
                                value={grandTotal}
                                InputProps={{ readOnly: true }}
                                size="small"
                            />
                        </Grid>
                        <Grid className="col-sm-2 mb-3" item xs={12} sm={6} md={3}>
                            <TextField
                                label="जमा रक्कम "
                                fullWidth
                                value={paidAmount}
                                onChange={(e) => {
                                    setPaidAmount(e.target.value);
                                    setRemaining((grandTotal - e.target.value).toFixed(2));
                                }}
                                size="small"
                            />
                        </Grid>
                        <Grid className="col-sm-2 mb-3" item xs={12} sm={6} md={3}>
                            <FormControl fullWidth size="small">
                                <InputLabel>पेमेंट टाईप </InputLabel>
                                <Select
                                    value={paytype}
                                    onChange={(e) => setPaytype(e.target.value)}
                                >
                                    <MenuItem value="Cash">Cash</MenuItem>
                                    <MenuItem value="Online Pay">Online Pay</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid className="col-sm-2 mb-3" item xs={12} sm={6} md={3}>
                            <TextField
                                label="बाकी / शिल्लक "
                                fullWidth
                                value={remaining}
                                InputProps={{ readOnly: true }}
                                size="small"
                            />
                        </Grid>
                        <Grid className="col-sm-2 mb-3" item xs={12} sm={6} md={3}>
                            <FormControl fullWidth size="small">
                                <InputLabel>Whatsapp </InputLabel>
                                <Select
                                    value={whatsapp}
                                    onChange={(e) => setwhatsapp(e.target.value)}
                                >
                                    <MenuItem value="No">No</MenuItem>
                                    <MenuItem value="Yes">Yes</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                </Box>

                {/* ---------------- SUBMIT ---------------- */}
                <Box mt={4} display="flex" justifyContent="center">
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={saveSale}
                        sx={{ px: 5, py: 1.2, fontWeight: "bold", borderRadius: 2 }}
                    >
                        विक्री ऍड करा
                    </Button>
                </Box>
            </Card>
        </Box>
    );
}
